// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fp-me-thumb[data-v-1b2b307a]{width:100%;position:absolute;top:0;left:0}.fp-me[data-v-1b2b307a].flowplayer .fp-timeline{display:none}.fp-me[data-v-1b2b307a].flowplayer.is-mouseover .fp-play,.fp-me[data-v-1b2b307a].flowplayer.is-mouseover .fp-pause,.fp-me[data-v-1b2b307a].flowplayer.is-mouseout .fp-play,.fp-me[data-v-1b2b307a].flowplayer.is-mouseout .fp-pause{display:none;opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
